import { useSelector } from 'react-redux'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { UseTypeFontSize } from '../../../common/hooks/useTypeFontSize'
import { Table } from '../../../common/table'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { AmountCell } from '../AmountCell'
import {
  selectOverdueSocialInsurance,
  selectOverdueSocialInsuranceIds,
} from '../store/slice'
import { fontSizes } from './../../../../configs/fontSize'
import { OVERDUE_SOCIAL_INSURANCE_TABLE, getThStyle } from './../helper'

const MAX_HEIGHT = {
  [fontSizes.Small.name]: 252,
  [fontSizes.Medium.name]: 272,
  [fontSizes.Large.name]: 284,
}

export const OverdueSocialInsurance = () => {
  const timezone = UseTimeZone()
  const typeFontSize = UseTypeFontSize()
  const rowIds = useSelector(selectOverdueSocialInsuranceIds())

  return (
    <Table
      ids={rowIds}
      getDataFromRedux={selectOverdueSocialInsurance}
      schema={Object.keys(OVERDUE_SOCIAL_INSURANCE_TABLE).map((key) => {
        const colId = OVERDUE_SOCIAL_INSURANCE_TABLE[key]
        return {
          colId,
          title: 'filingStatus.' + key,
          isI18n: true,
          thStyle: {
            justifyContent:
              colId === OVERDUE_SOCIAL_INSURANCE_TABLE.AMOUNT ||
              colId === OVERDUE_SOCIAL_INSURANCE_TABLE.OUTSTANDING_MONTHS
                ? 'flex-end'
                : 'flex-start',
          },
          tdStyle: {
            textAlign:
              colId === OVERDUE_SOCIAL_INSURANCE_TABLE.AMOUNT ||
              colId === OVERDUE_SOCIAL_INSURANCE_TABLE.OUTSTANDING_MONTHS
                ? 'right'
                : 'left',
          },
          parentThStyle: getThStyle(colId),
          render: (data, { rowId, locale }) => {
            switch (colId) {
              case OVERDUE_SOCIAL_INSURANCE_TABLE.PUBLICATION_DATE:
                return formatDateTime(data, FORMAT.DATE, locale, timezone)
              case OVERDUE_SOCIAL_INSURANCE_TABLE.AMOUNT:
                return (
                  <AmountCell
                    rowId={rowId}
                    data={data}
                    getDataFromRedux={selectOverdueSocialInsurance}
                  />
                )
              default:
                return (
                  <TextEllipsisStaticLine
                    text={data}
                    isI18n={false}
                    lineClamp={2}
                  />
                )
            }
          },
        }
      })}
      noDataText="filingStatus.NO_DATA_SOCIAL_INSURANCE"
      autoHeightMax={MAX_HEIGHT[typeFontSize]}
    />
  )
}
